// import { theme } from "themes/default/theme"
// import { minWidth1200, maxWidth600 } from "themes/default/breakpoints"

import { masterBreakPoint, maxWidth600 } from "themes/default/breakpoints"

export const styles = {
  dialog: (theme) => ({
    backgroundColor: theme.palette.background.default,
    [maxWidth600]: {
      m: 1,
      width: "calc(100% - 32px)",
    },
  }),
  headerContainer: (theme) => ({
    position: "relative",
    backgroundColor: theme.palette.licenses.surface,
    borderBottom: `4px solid ${theme.palette.primary.main}`,
    p: 2,
    px: 4,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  }),
  downwardPointer: (theme) => ({
    position: "absolute",
    bottom: "-10px",
    left: "50%",
    transform: "translateX(-50%) rotate(45deg)",
    width: "20px",
    height: "20px",
    backgroundColor: theme.palette.licenses.surface,
    zIndex: 2,
  }),
  leftPattern: {
    position: "absolute",
    left: "24px",
    top: "50%",
    transform: "translateY(-50%)",
    opacity: 0.12,
    pointerEvents: "none",
    display: { xs: "none", sm: "block" },
  },
  rightPattern: {
    position: "absolute",
    right: 0,
    top: 0,
    height: "100%",
    opacity: 0.12,
    pointerEvents: "none",
    display: { xs: "none", sm: "block" },
  },
  title: (theme) => ({
    color: theme.palette.common.white,
    textAlign: "center",
    mb: 1,
    position: "relative",
    zIndex: 1,
    fontSize: "2.3rem",
    [masterBreakPoint]: {
      fontSize: "1.8rem",
    },
  }),
  titleHighlight: (theme) => ({
    color: theme.palette.primary.main,
    fontSize: "2.3rem",
    [masterBreakPoint]: {
      fontSize: "1.8rem",
    },
  }),
  subtitle: (theme) => ({
    color: theme.palette.common.white,
    fontSize: "1.2rem",
    textAlign: "center",
    position: "relative",
    [masterBreakPoint]: {
      fontSize: "1rem",
    },
  }),
  subtitleHighlight: (theme) => ({
    color: theme.palette.primary.main,
    fontSize: "1.2rem",
    [masterBreakPoint]: {
      fontSize: "1rem",
    },
  }),
  content: (theme) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    p: 2,
    px: 4,
    backgroundColor: theme.palette.background.default,
    [masterBreakPoint]: {
      p: 1,
      px: 4,
    },
  }),
  graphicArea: {
    position: "relative",
    // width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    my: 2,
    py: 2,
  },
  bgCircle: (theme) => ({
    position: "absolute",
    minHeight: 150,
    minWidth: 150,
    width: "20vh",
    height: "20vh",
    borderRadius: "50%",
    backgroundColor: theme.palette.licenses.surface2,
    zIndex: 0,
    [maxWidth600]: {
      minHeight: 100,
      minWidth: 100,
      width: "15vh",
      height: "15vh",
    },
  }),
  mascot: {
    minHeight: 150,
    height: "20vh",
    objectFit: "contain",
    position: "relative",
    zIndex: 2,
    filter: "drop-shadow(0px 12px 24px rgba(0, 0, 0, 0.12))",
    [maxWidth600]: {
      minHeight: 100,
      height: "15vh",
    },
  },
  badgeLeft: {
    position: "absolute",
    left: { xs: "5%", sm: "12%", md: "18%" },
    top: "45%",
    transform: "translateY(-50%)",
    width: { xs: "55px", sm: "65px" },
    height: { xs: "55px", sm: "65px" },
    borderRadius: "50%",
    backgroundColor: "#FFFFFF",
    boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.08)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 3,
    animation: "floatLeft 4s ease-in-out infinite",
    "@keyframes floatLeft": {
      "0%, 100%": { transform: "translateY(-50%)" },
      "50%": { transform: "translateY(-60%)" },
    },
  },
  badgeRight: {
    position: "absolute",
    right: { xs: "5%", sm: "12%", md: "18%" },
    top: "40%",
    transform: "translateY(-50%)",
    width: { xs: "55px", sm: "65px" },
    height: { xs: "55px", sm: "65px" },
    borderRadius: "50%",
    backgroundColor: "#FFFFFF",
    boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.08)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 3,
    animation: "floatRight 4s ease-in-out infinite",
    "@keyframes floatRight": {
      "0%, 100%": { transform: "translateY(-50%)" },
      "50%": { transform: "translateY(-30%)" },
    },
  },
  chartBars: {
    display: "flex",
    alignItems: "flex-end",
    gap: "5px",
    height: "26px",
  },
  chartBar1: {
    width: "6px",
    height: "12px",
    backgroundColor: "#3B82F6",
    borderRadius: "3px",
  },
  chartBar2: {
    width: "6px",
    height: "20px",
    backgroundColor: "#1D4ED8",
    borderRadius: "3px",
  },
  chartBar3: {
    width: "6px",
    height: "26px",
    backgroundColor: "#FE8033",
    borderRadius: "3px",
  },
  shieldContainer: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  checkBadge: {
    position: "absolute",
    bottom: "-4px",
    right: "-6px",
    width: "18px",
    height: "18px",
    borderRadius: "50%",
    backgroundColor: "#FE8033",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "2px solid #FFFFFF",
  },
  featuresContainer: {
    width: "100%",
    mt: 3,
    mb: 2,
    [maxWidth600]: {
      my: 1,
    },
  },
  featureItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: 2,
  },
  featureIconWrapper: (theme) => ({
    backgroundColor: theme.palette.licenses.surface2,
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0,
    position: "relative",
  }),
  featureTitle: (theme) => ({
    fontWeight: 700,
    color: theme.palette.licenses.surface,
    fontSize: "1rem",
  }),
  featureDesc: (theme) => ({
    color: theme.palette.licenses.text3,
    fontSize: "0.875rem",
  }),
  featureDivider: (theme) => ({
    position: "absolute",
    right: 0,
    top: "10%",
    height: "80%",
    width: "1px",
    backgroundColor: theme.palette.licenses.text,
    display: "block",
  }),
  actionsWrapper: {
    width: "100%",
    mt: 4,
  },
  buttonCancel: (theme) => ({
    flex: 1,
    py: 1.5,
    borderRadius: 2.5,
    borderColor: theme.palette.licenses.surface,
    color: theme.palette.licenses.surface,
    textTransform: "none",
    borderWidth: "2px",
    fontWeight: "bold",
    "&:hover": {
      borderColor: theme.palette.licenses.surface,
      backgroundColor: theme.palette.licenses.surface2,
      borderWidth: "2px",
    },
  }),
  buttonConfirm: (theme) => ({
    flex: 1,
    py: 1.5,
    borderRadius: 2.5,
    textTransform: "none",
    fontWeight: "bold",
  }),
  reminderBanner: (theme) => ({
    mt: 3,
    width: "100%",
    backgroundColor: theme.palette.licenses.surface2,
    borderRadius: 2,
    py: 1.5,
    px: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 1.5,
    textAlign: "center",
    [maxWidth600]: {
      my: 1.5,
    },
  }),
  reminderText: (theme) => ({
    color: theme.palette.licenses.surface,
    fontSize: "1rem",
  }),
  footerNote: {
    mt: 2.5,
    mb: 0.5,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  footerText: (theme) => ({
    color: theme.palette.licenses.text2,
    fontSize: "1rem",
  }),
  secureIcon: (theme) => ({
    fontSize: "1.2rem",
    color: theme.palette.licenses.text2,
    mr: 0.25,
  }),
  icon: {
    height: 45,
    objectFit: "contain",
    position: "relative",
    zIndex: 2,
  },
}
